import { isMockMode, post, simulateDelay } from "../api";

export const updateServiceLicence = (data) => {
	if (isMockMode()) {
		const testData = { success: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Licences/UpdateServiceLicence`, data, {
		successMessage: "License updated successfully",
	});
};
